import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "ulysses/api";
import markup from "ulysses/features/core_dialogs.html";

"use strict";
$(document).ready(function() { $(markup).appendTo($("body")); });

$.extend(uly.actions, {
    actApplyChanges: function(ev, $elt, ui) {
        var model = {
            message:"",
            items: ko.observableArray([{"message":uly.strings.applying_changes, "icon":"fa-save" }])
        };
        var dialog_def = uly.dialogs.execute($("#dlg-pending-changes-tmpl").html(), {
            "keyboard":true,
            "title":uly.strings.application_restart,
            "raw_data":true,
            "buttons":[]
        }, model);
        var wait_for_app = function() {
            var waiter = Promise.Deferred();
            waiter.counter = ko.observable(0);
            var pinger = function() {
                uly.api.ping().done(function() {
                    waiter.resolve();
                }).fail(function() {
                    waiter.counter(waiter.counter()+1);
                    setTimeout(pinger, 1000);
                });
            };
            pinger();
            return waiter;
        };

        var reload_key = ""+(new Date().getTime());
        var subscription = uly.subscribeToEvent(reload_key, function(topic, payload) {
            var message = payload.message;
            if (message && message.kind) {
                message = message.message;
            }
            model.items.push({
                "message":message,
                "icon":payload.status == "reload" ? "fa-refresh" : payload.status ? "fa-check" : "fa-warning"
            });
            if (payload.status == "reload") {
                uly.unsubscribeToEvent(reload_key, subscription);
                subscription = null;
                var waiter = wait_for_app();
                waiter.counter.subscribe(function(val) {
                    model.items.push({
                        "message":uly.strings.application_wait,
                        "icon":"fa-spin"
                    });
                });
                waiter.done(function() {
                    dialog_def.$elt.modal("hide");
                    dialog_def.resolve(_("general_admin_application_reloaded", "Application reloaded"));
                    uly.publish("application.restart",{});
                    uly.utils.show_results({"success":true, "info":_("general_admin_info_changes_applied_and_application_restarted", "Changes applied and application restarted") });

                });
            }
        }, dialog_def.$elt || $elt).done(function(sub) {
            uly.api
                .start()
                .follow("uly:admin")
                .post("uly:changes", { reload_key:reload_key })
                .done(function(result) {
                    console.log("pending changes result:", result);
                }).fail(function(error) {
                    dialog_def.$elt.model("hide");
                    dialog_def.reject("Error");
                    dialog_def = null;
                    uly.unsubscribeToEvent(reload_key, subscription);
                    subscription = null;
                });
        });
    },
    "actCancelChanges": function(ev, $elt, ui) {
        uly.api
            .start()
            .follow("uly:admin")
            .delete("uly:changes")
            .done(function(result) {
                uly.utils.show_results(result);
                uly.actions.navigateto("/admin/changes");
            }).fail(function(error) {
                uly.utils.show_results(error);
            });
    },
    "takesnapshot": function(ev, $elt, ui) {
        uly.api.start().follow("uly:admin").
            get_uri("uly:snapshots", {"restricted":false}).done(function(uri) {
                document.location.href = uri;
            });
    },
    "takerestrictedsnapshot": function(ev, $elt, ui) {
        uly.api.start().follow("uly:admin").
            get_uri("uly:snapshots", {"restricted":true}).done(function(uri) {
                document.location.href = uri;
            });
    },
    "savesettings": function(ev, $elt, ui){
        var data = ko.unwrap(ui.context.$parent.data);
        var resource = uly.utils.get_bound_entity($elt);
        data = ko.toJS(data);
        delete data.__ko_mapping__;
        HalResource(resource).put(null, data).done(function(result) {
            uly.utils.show_results(result);
            if (result.location) {
                uly.actions.navigateto(result.location);
            }
        }).fail(function(error) {
            uly.utils.show_results(error);
        });

    },
    "savemodules": function(ev, $elt, ui){
        return uly.actions.savesettings(ev,$elt,ui);
    },
    "admin_newtheme": function(ev, $elt, ui, initialTheme) {
        uly.dialogs.execute("<div class='form-group'><label>Theme</label><input type='text' data-bind='value:name' name='name' class='form-control' /></div>", {
            "keyboard":true,
            "title":uly.strings.new_theme,
        }, { "name": initialTheme || "" }).done(function([result]) {
            initialTheme = ko.unwrap(result.name);
            uly.api.start().follow("uly:admin").follow("uly:theme").post(null, {
                "name": ko.unwrap(result.name)
            }).done(function(data) {
                uly.actions.navigateto("/admin/theme/" + ko.unwrap(result.name));
            }).fail(function(error) {
                uly.utils.show_results(error);
                uly.actions.admin_newtheme(ev, $elt, ui, initialTheme);
            });
        });
    },
    "admin_newmenu": function(ev, $elt, ui, initialName) {
        uly.dialogs.execute("<div class='form-group'><label>Menu</label><input type='text' data-bind='value:name' name='name' class='form-control' /></div>", {
            "keyboard":true,
            "title":uly.strings.new_menu
        }, { "name": initialName || "" }).done(function([result]) {
            initialName = ko.unwrap(result.name);
            uly.api.start().follow("uly:admin").follow("uly:menu").post(null, {
                "name": ko.unwrap(result.name)
            }).done(function(data) {
                if (data.location) {
                    uly.actions.navigateto(data.location);
                } else {
                    uly.actions.navigateto("/admin/menu/" + ko.unwrap(result.name));
                }
            }).fail(function(error) {
                uly.utils.show_results(error);
                uly.actions.admin_newmenu(ev, $elt, ui, initialName);
            });
        });
    },
    "deletesettings": function(ev, $elt, ui){
        var resource = uly.utils.get_bound_entity($elt);
        HalResource(resource).delete(null).done(function(result) {
            uly.utils.show_results(result);
            window.history.back();
        }).fail(function(error) {
            uly.utils.show_results(error);
        });
    },
    "createsettings": function(ev, $elt, ui) {
        var data = ko.unwrap(ui.context.$parent.data);
        var resource = uly.utils.get_bound_entity($elt);
        data = ko.toJS(data);
        delete data.__ko_mapping__;
        delete data.settings;
        data = {"key": data.new_key, "settings": data.new_data};
        console.log("datA:", data);
        HalResource(resource).post(null, data).done(function(result) {
            uly.utils.show_results(result);
            if (result.location) {
                uly.actions.navigateto(result.location);
            }
        }).fail(function(error) {
            uly.utils.show_results(error);
        });
    }
});

ko.bindingHandlers.admodelfieldpicker = {
    init: function(elt, va, allbindings, model, context) {
        $(elt).on("click tap", function() {
            //open the data field picker dialog.
            var modeloptions = ko.unwrap(allbindings().modeloptions) || {};
            var currentPath = ko.unwrap(va());
            modeloptions= $.extend({}, modeloptions, { "path":currentPath });
            var entity = ko.unwrap(modeloptions.root_entity);
            if (entity && entity[0] == '?')
            {
                var tokens = entity.slice(1).split(".");
                var cval = context.$data;
                $.each(tokens, function(idx,val) {
                    if (val == "$parent")
                        cval = context.$parent;
                    else if (val == "$data")
                        cval = context.$data
                    else cval = ko.unwrap(cval[val]);
                });
                entity = ko.unwrap(cval);
            }
            var newoptions = $.extend({}, modeloptions, { "root_entity":entity});

            uly.dialogs.show("dlg_select_field", { "buttons":{"ok":_("general_admin_ok_select", "Select"), "cancel":_("general_admin_cancel_cancel", "Cancel")}, "title":_("general_admin_title_select_field", "Select field")}, newoptions).done(function([result]) {
                $(elt).val(result).change();
            });
        });

        return ko.bindingHandlers.value.init(elt, va, allbindings, model, context);

    },
    update: function(elt, va, allbindings, context, model) {
        return ko.bindingHandlers.value.update(elt, va, allbindings, model, context);
    }
};
